import { PropsWithChildren } from 'react'

import { HostPlatformProvider } from './HostPlatformProvider'

export const HubPlatformProvider = ({ children }: PropsWithChildren) => {
  return <HostPlatformProvider platform="hub">{children}</HostPlatformProvider>
}
